import React from 'react';
import PropTypes from 'prop-types';
import LinkButton, { LINK_BUTTON_THEMES } from 'components/LinkButton';

import './Categories.scss';

const Categories = ({
  categories,
  labels = {
    all: 'Alle',
    categoriesNavigationAriaLabel: 'Filter med Kategorier',
  },
  onClick,
  selectedCategory,
}) => (
  <nav className="tags" aria-label={labels.categoriesNavigationAriaLabel}>
    <LinkButton
      text={labels.all}
      onClick={onClick}
      theme={
        selectedCategory
          ? LINK_BUTTON_THEMES.outlineDark
          : LINK_BUTTON_THEMES.dark
      }
      additionalAttributes={{
        role: 'button',
      }}
      className="tag"
    />
    {categories.map(c => (
      <LinkButton
        key={c.id}
        text={c.name}
        onClick={onClick}
        theme={
          selectedCategory && selectedCategory.id === c.id
            ? LINK_BUTTON_THEMES.dark
            : LINK_BUTTON_THEMES.outlineDark
        }
        additionalAttributes={{
          'data-category': c.id,
          role: 'button',
        }}
        className="tag"
      />
    ))}
  </nav>
);

Categories.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  labels: PropTypes.shape({
    all: PropTypes.string.isRequired,
    categoriesNavigationAriaLabel: PropTypes.string.isRequired,
  }),
  onClick: PropTypes.func.isRequired,
  selectedCategory: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }),
};

export default Categories;
